export interface UtmParams {
  utm_medium: string
  utm_source: string
  utm_campaign: string
  utm_content: string
  utm_channel: string
  utm_term: string
}

export const EMPTY_UTM_PARAMS: UtmParams = {
  utm_medium: '',
  utm_source: '',
  utm_campaign: '',
  utm_content: '',
  utm_channel: '',
  utm_term: '',
}

const STORAGE_KEY = 'pdftools_utm_params'

const readFromUrl = (): UtmParams => {
  const params = new URLSearchParams(window.location.search)
  return {
    utm_medium: params.get('utm_medium') || '',
    utm_source: params.get('utm_source') || '',
    utm_campaign: params.get('utm_campaign') || '',
    utm_content: params.get('utm_content') || '',
    utm_channel: params.get('utm_channel') || '',
    utm_term: params.get('utm_term') || '',
  }
}

// Persists UTMs from the current URL into sessionStorage so they survive
// in-app navigation (which strips query params). Last-touch: if a new URL
// carries any UTM, it overwrites the stored set; URLs without UTMs leave
// storage untouched.
export const captureUtmParams = (): void => {
  if (typeof window === 'undefined') return

  const fromUrl = readFromUrl()
  const hasAny = Object.values(fromUrl).some(Boolean)
  if (!hasAny) return

  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(fromUrl))
  } catch {
    // sessionStorage may be unavailable (private mode, quota); fail silently
  }
}

export const getUtmParams = (): UtmParams => {
  if (typeof window === 'undefined') return EMPTY_UTM_PARAMS

  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY)
    if (stored) {
      return { ...EMPTY_UTM_PARAMS, ...JSON.parse(stored) }
    }
  } catch {
    // ignore and fall back to URL
  }

  return readFromUrl()
}